// 소품 입히기·벗기기. 프로토타입 setAgentItem·setAgentFace 1633–1648, equip* 3764–3775.
import type * as THREE from 'three';
import { MENUS, type FaceItemId, type HandItemId, type HeadItemId, type LagoonMaskId } from '@capy/shared';
import { makeHeadItem } from '../items/head';
import { makeBubble, makeCukes, makeMask } from '../items/face';
import { makeMitt, makeScratcher } from '../items/hand';
import { itemFx } from '../items/fx';
import { poseHooks, type Room } from './pose';
import type { Capy } from './agent';

export type FaceKey = FaceItemId | LagoonMaskId | 'none';

const isLagoonMask = (k: string): k is LagoonMaskId => k in MENUS.maskbar;

/** 머리 소품. drop이면 위에서 떨어져 튕기며 얹힌다 (내 카피바라가 고를 때, 움직임 줄이기 설정이면 끔). */
export function setHead(a: Capy, key: HeadItemId | 'none', dropAt?: number): void {
  a.itemKey = key;
  if (a.item) { a.c.itemAnchor.remove(a.item); a.item = null; }
  if (key === 'none') return;
  a.item = makeHeadItem(key);
  a.c.itemAnchor.add(a.item);
  if (dropAt != null) a.dropStart = dropAt;
}

/** 얼굴 소품. 라군 팩은 씻으면 지워지고 원래 쓰던 얼굴 소품으로 돌아간다. */
export function setFace(a: Capy, key: FaceKey): void {
  const head = a.c.headG;
  if (a.bubble) { head.remove(a.bubble); a.bubble = null; }
  if (a.mask) { head.remove(a.mask); a.mask = null; }
  if (a.cukes) { head.remove(a.cukes); a.cukes = null; }
  a.faceKey = key;
  if (!isLagoonMask(key)) a.wornFace = key;
  if (key === 'cucumber') { a.cukes = makeCukes(); head.add(a.cukes); }
  if (key === 'kbeauty' || isLagoonMask(key)) { a.mask = makeMask(key); head.add(a.mask); }
  if (key === 'bubble') { a.bubble = makeBubble(); head.add(a.bubble); a.bubbleK = 1; }
}

/** 손 소품. 프로토타입처럼 찜질방에서만 모델이 붙는다. world: 효자손을 붙일 방의 루트. */
export function setHand(a: Capy, key: HandItemId | 'none', room: Room, world: THREE.Object3D): void {
  a.handKey = key;
  if (a.mitt) { a.mitt.parent?.remove(a.mitt); a.mitt = null; }
  a.c.paws[0]!.visible = true;
  a.scratcher = null;
  if (key === 'scrubmitt' && room === 'jjim') a.mitt = makeMitt(a.c);
  if (key === 'scratcher' && room === 'jjim') { a.scratcher = makeScratcher(world); a.mitt = a.scratcher.g; }
}

poseHooks.itemFx = itemFx;
// 씻기가 끝까지 끝나면 라군 팩을 지운다 (내 카피바라는 원래 얼굴 소품으로, NPC는 맨얼굴로).
poseHooks.washEnd = (a, finished) => {
  if (!(finished && a.faceKey && isLagoonMask(a.faceKey))) return false;
  setFace(a, a.isPlayer ? (a.wornFace ?? 'none') : 'none');
  return true;
};
